import { Injectable, Optional } from '@angular/core';
import { INDDI18nServiceConfigResources, NDDI18nServiceConfigResources, NDDTranslationResourceService } from '@ndk/ng-translation';

/**
 * Interface com atributos necessários para configuração i18n.
 *
 * @export
 * @interface INDDFilterI18nServiceConfigResources
 * @extends {INDDI18nServiceConfigResources}
 */
export interface INDDFilterI18nServiceConfigResources extends INDDI18nServiceConfigResources {
    addNewRule?: string;
    limitTitle?: string;
    limitExceedMessage?: string;
    notEqual?: string;
    notInitialLowerFinal?: string;
    notInitialGreaterFinal?: string;
    notFinalLowerInitial?: string;
    notFinalGreaterInitial?: string;
    to?: string;
}

/**
 * Configurações i18n gerais do ndd-ng-filter.
 *
 * @export
 * @class NDDFilterI18nServiceConfig
 * @implements {NDDFilterServiceConfigResources}
 */
export class NDDFilterI18nServiceConfig implements NDDI18nServiceConfigResources {
    public i18n: boolean;
    public resources: INDDFilterI18nServiceConfigResources = {
        addNewRule: 'Adicionar nova regra',
        field: 'Campo',
        limitTitle: 'Limite Atingido',
        limitExceedMessage: 'Número máximo de regras atingido. Para adicionar mais regras, remova pelo menos uma regra do filtro.',
        notEqual: 'Os valores não podem ser iguais',
        notInitialLowerFinal: 'O valor inicial não pode ser menor que o final',
        notInitialGreaterFinal: 'O valor inicial não pode ser maior que o final',
        notFinalLowerInitial: 'O valor final não pode ser menor que o inicial',
        notFinalGreaterInitial: 'O valor final não pode ser maior que o inicial',
        operator: 'Operador',
        to: 'até',
        value: 'Valor',
    };
}

/**
 * Serviço de configuração i18n do filtro
 *
 * @export
 * @interface INDDFilterI18nServiceConfigResources
 * @extends {INDDI18nServiceConfigResources}
 */
@Injectable()
export class NDDFilterI18nService extends NDDTranslationResourceService {
    constructor(@Optional() config: NDDFilterI18nServiceConfig) {
        super(config, new NDDFilterI18nServiceConfig());
    }
}
